












































































import StateModified from "@/components/review_states/StateModified.vue"
import StateNew from "@/components/review_states/StateNew.vue" # done
import StateSignalingWriting from "@/components/review_states/StateSignalingWriting.vue"
import StateInformationNeeded from "@/components/review_states/StateInformationNeeded.vue"
import StateWaitingForInformation from "@/components/review_states/StateWaitingForInformation.vue"
import StateClassified from "@/components/review_states/StateClassified.vue"
import StateSignalingSent from "@/components/review_states/StateSignalingSent.vue"
import StateAnswerWriting from "@/components/review_states/StateAnswerWriting.vue"
import StateAnswerTextValidation from "@/components/review_states/StateAnswerTextValidation.vue"
import StateAnswerAccepted from "@/components/review_states/StateAnswerAccepted.vue"
import StateAnswerPublished from "@/components/review_states/StateAnswerPublished.vue"
import StateTranslationNeeded from "@/components/review_states/StateTranslationNeeded.vue"
import StateStratalisPublication from "@/components/review_states/StateStratalisPublication.vue"

import ReviewStateNotification from "@/components/ReviewStateNotification.vue"
import Modal from '@/components/Modal'

import mutations from "@/gql/mutations.coffee"
import settings from "@/settings.coffee"
import moment from "moment"
import tools from "@/tools.coffee"

moment.locale("fr")

export default {
    "name": 'ReviewState',
    "components": {
        StateNew
        StateModified
        StateSignalingWriting
        StateInformationNeeded
        StateClassified,
        StateSignalingSent,
        StateAnswerWriting,
        StateAnswerAccepted,
        StateAnswerPublished,
        StateTranslationNeeded,
        ReviewStateNotification,
        StateAnswerTextValidation;
        StateStratalisPublication;
        Modal,
        StateWaitingForInformation,
    },
    "props": {
        "context": {
            "type": Object,
            "required": true
        }
        "review": {
            "type": Object,
            "required": true
        }
        "can_delete": false
        "review": false
    }
    "data": ()->
        return {
            "showWarning": false
            "show_menu": false
            "loading": false
            "loading_error": false
            "level": "default"
            "email_set": []
        }
    "computed":
        "to_gathering": ()->
            return @context.class_name == "AnswerWriting"
        "content": ()->
            # convert the graphql json string to data structure
            if @context.data?
                if typeof @context.data == "string"
                    @context.data = JSON.parse(@context.data)
            return {
                "context": tools.deep_copy(@context)
            }
        "class_state_active": ()->
            return {
                "is-primary": @context.active
            }
        "human_created_on": ()->
            result = moment(@context.created_on).fromNow() + " (" + moment(@context.created_on).format("DD/MM/YYYY HH:mm:ss")+")"
            return result

    "methods":
        "prioritizedActions": (who)->
            if this.context.class_name == 'New'
                priorActions = []
                otherActions = []
                this.context.list_actions.forEach (action) ->
                    if action.slug == 'classify' 
                        priorActions[0] = action
                    else if action.slug == 'write_an_answer' 
                        priorActions[1] = action
                    else if action.slug == 'ask_information'
                        priorActions[2] = action
                    else 
                        otherActions.push(action)
                priorActions = priorActions.filter (action) -> action
                return priorActions.concat otherActions
            else 
                return this.context.list_actions.filter (act)->
                    return act.groups.indexOf(who) >= 0
        "delete_state": ()->
            @$store.commit("delete_edited_fields", {
                key: "text_native"
            })
            @$store.commit("delete_edited_fields", {
                key: "text_fr"
            })
            self = @
            @showWarning = true
            #self.$emit("FlowDetail:delete_state")
        "deleteConfirmed": ()->
            @showWarning = false
            @$emit("FlowDetail:delete_state")
        "set_level": (level)->
            self = @
            self.level = level
        "save_internal_state": (data)->
            self = @
            @loading = true
            serialized = JSON.stringify(data)
            # serialized = serialized.replace(/"/g, '\\"')
            # serialized = btoa(serialized)
            serialized = tools.b64_encode(serialized)

            mutations.run("update_state_data", [@context.uid, serialized])
            .then ()->
                self.loading = false
                self.$store.dispatch("notify", {
                    text: "Enregistrement effectué",
                    seconds: 2,
                    level:"success"})
            .catch ()->
                self.loading = false
                self.$store.dispatch("notify", {
                    text: "Erreur à l'enregistrement",
                    seconds: 2,
                    level:"danger"})

        "show_action": (action)->
            return "mhr" in action.groups
        "delete": ()->
            self = this
            data = await self.$http.post(settings.graphqlApiUrl, {query: mutations.gql_mutation_state_delete(self.context.uid)})
        "call_action": (slug)->
            if @context.active
                self = this
                data = await self.$http.post(settings.graphqlApiUrl, {query: mutations.gql_mutation_state_call_action(self.context.uid, slug)})
        "handleEmailSetUpdate": (newEmailSet) ->
            @email_set = newEmailSet

    "updated": ->
        if @context.active
            @set_level("primary")
        else
            @set_level("default")
    "mounted": ->
        @loading = false
    "created": ()->
        @loading = true
}
